import httpClient from '@/api/httpClient';

export const getListOfActiveCities = locale => {
  const params = new URLSearchParams({ locale });

  return httpClient.get(`/api/webShop/arabicCities?${params}`);
};
